import { useWeb3ModalProvider } from "@web3modal/ethers/react";
import { BrowserProvider, Contract, Interface } from "ethers";
import { useEffect, useState } from "react";
import { useWallletContext } from "../hook/useWalletContext";
import STAKING_ABI from "../common/STAKING_ABI.json";
import dateFormat from "dateformat";
import { useNavigate } from "react-router-dom";
import {
  convertFromGmtOffsetTime,
  getLocalGMTOffsetString,
} from "../common/helper";

export const DashboardDateCard = () => {
  const navigate = useNavigate();

  const { walletProvider } = useWeb3ModalProvider();
  const { currentAddress } = useWallletContext();

  const [listDate, setListDate] = useState<Date | undefined>();
  const [startDate, setStartDate] = useState<Date | undefined>();

  useEffect(() => {
    if (!currentAddress) {
      return;
    }

    getContractDate();
  }, [currentAddress]);

  const getContractDate = async () => {
    try {
      const provider = new BrowserProvider(walletProvider!);
      const signer = await provider.getSigner();

      const staking = new Contract(
        process.env.REACT_APP_STAKING_50_CONTRACT!,
        new Interface(STAKING_ABI).format(false),
        signer
      );

      const listDate = parseInt((await staking.listDate()).toString());
      const startDate = parseInt((await staking.startDate()).toString());

      if (listDate) {
        setListDate(convertFromGmtOffsetTime(new Date(listDate * 1000)));
        setStartDate(convertFromGmtOffsetTime(new Date(startDate * 1000)));
      } else {
        setListDate(undefined);
        setStartDate(undefined);
      }
    } catch (err) {
      console.log(err);

      setListDate(undefined);
      setStartDate(undefined);
    }
  };

  return (
    <div className="col-span-12 xl:col-span-6 xxl:col-span-6">
      <div className="box overflow-hidden">
        <div className="box-body">
          <div className="flex">
            <div className="flex space-x-3 rtl:space-x-reverse">
              <div className="avatar rounded-sm bg-primary/10 dark:primary/10 flex">
                <i className="ti ti-calendar-time text-secondary mx-auto my-auto text-3xl margin-inline-end-auto"></i>
              </div>
              <h6 className="text-lg font-medium text-gray-800 mb-2 dark:text-white my-auto ">
                Contract Date
              </h6>
            </div>
          </div>
          <div className="mt-2 grid grid-cols-12">
            <div className="col-span-12 md:col-span-6 xxl:col-span-6">
              <p className="text-s text-gray-400 ">List Date(GMT 00:00)</p>
            </div>
            <div className="col-span-12 md:col-span-6 xxl:col-span-6 text-end ">
              <p className="text-s font-semibold text-gray-800 dark:text-white">
                {listDate ? dateFormat(listDate, "yyyy-mm-dd HH:MM:ss") : ""}
              </p>
            </div>
          </div>
          <div className="mt-2 grid grid-cols-12">
            <div className="col-span-12 md:col-span-6 xxl:col-span-6">
              <p className="text-s text-gray-400 ">Start Date(GMT 00:00)</p>
            </div>
            <div className="col-span-12 md:col-span-6 xxl:col-span-6 text-end ">
              <p className="text-s font-semibold text-gray-800 dark:text-white">
                {startDate ? dateFormat(startDate, "yyyy-mm-dd HH:MM:ss") : ""}
              </p>
            </div>
          </div>
          <div className="mt-2 text-center">
            <button
              type="button"
              className="ti-btn ti-btn-primary"
              onClick={() => navigate("/setting")}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
